import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { useDispatch } from 'react-redux';
import WeddingWebsiteGif from 'assets/images/digitalSaveTheDate/website.gif';
import { hideModal } from '../../../../actions/modalActions';
import styles from './styles.module.less';

const CreateWeddingWebsite = () => {
  const dispatch = useDispatch();

  const onConfirm = () => {
    dispatch(hideModal());
    window.open('/wedding/manage/website/designs', '_blank');
  };

  return (
    <div className={styles.container}>
      <img aria-label="Wedding Website Gif" className={styles.headerImg} src={WeddingWebsiteGif} />
      <div className={styles.header}>Create your wedding website</div>
      <div className={styles.content}>
        It&apos;s the easiest way to keep guests in-the-know. Share updates, schedules, videos,
        photos, registry, and more.
      </div>
      <div className={styles.buttonContainer}>
        <ButtonV2 variant="secondary" onClick={() => dispatch(hideModal())}>
          Maybe Later
        </ButtonV2>
        <ButtonV2 onClick={onConfirm}>Get Started</ButtonV2>
      </div>
    </div>
  );
};

export default {
  component: CreateWeddingWebsite,
  className: styles.modalWidthOverride,
};
